import { buildQueryParams, requestBuilder } from '../../../http/RequestBuilder';
import type {
    TransactionTableRequest,
    TransactionTableResponse,
} from '../../types/Transactions';

const useGetTransactionTable = requestBuilder.query<
    TransactionTableResponse,
    TransactionTableRequest
>({
    endpoint: ({ bankAccountId, ...query }) =>
        `/api/transactions/table/${bankAccountId}${buildQueryParams(query)}`,
    queryKey: ({ bankAccountId, ...query }) =>
        `getTransactionTable/${bankAccountId}${buildQueryParams(query)}`,
});

export default useGetTransactionTable;
